import { DataTable, Separator } from "@bleu.builders/ui";
import React from "react";
import { useLoaderData, useParams } from "react-router-dom";

import { withPaywall } from "#/components/WithPaywall";
import { replaceParams, UserPagePath } from "#/lib/pagesHelper";
import { canViewDiagnosis } from "#/lib/permissions";
import { useSWRDataTableWithRedirect } from "#/utils/useSWRDataTableWithRedirect";

import { ThesesTableBody } from "../theses/(components)/ThesesTableBody";
import { ThesesArchivedNote } from "../theses/(components)/ThesisTableArchivedNotification";
import {
  calculateOpportunities,
  ThesesTableToolbar,
} from "../theses/(components)/ThesisTableToolbar";
import { DownloadReportDialog } from "./(components)/DownloadReportDialog";

interface DiagnosisMatchesLoader {
  data: {
    accessorKey: string;
    title: string;
    value: string;
  }[];
}

function DiagnosisMatches() {
  const { data: diagnosis } = useLoaderData() as DiagnosisMatchesLoader;
  const params = useParams();
  const { data, error, isLoading, tableState, setTableState } =
    useSWRDataTableWithRedirect(
      replaceParams(UserPagePath.DIAGNOSES_MATCHES, params),
      {
        grouping: ["tax"],
        sorting: [{ id: "tax", desc: false }],
      },
    );

  const hasAnyArchived = data?.data?.some((d) => d.archived);

  return (
    <div className=" space-y-4">
      <div className="flex items-center mb-5 justify-center">
        <h1 className="text-2xl font-semibold font-title">
          Seu diagnóstico para{" "}
          <span className="text-primary">
            {diagnosis.find((item) => item.accessorKey === "title").value}
          </span>{" "}
          apontou {calculateOpportunities(data)} oportunidades disponíveis
        </h1>
      </div>
      <Separator />
      <div className="mt-5">
        <div className="my-10 space-y-4">
          <DataTable
            data={data}
            error={error}
            tableState={tableState}
            setTableState={setTableState}
            setSelectedData={null}
            setQueryToParams={true}
            isLoading={isLoading}
          >
            <div className="space-y-4">
              <ThesesTableToolbar
                showGroupOptions
                actions={<DownloadReportDialog diagnosis={diagnosis} />}
              />
              {hasAnyArchived && <ThesesArchivedNote />}
              <ThesesTableBody
                showOpportunitiesCount
                showRecentlyCreated={false}
              />
            </div>
          </DataTable>
        </div>
      </div>
    </div>
  );
}

export default withPaywall(DiagnosisMatches, canViewDiagnosis);
